import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import { usePublishTradingOfferModal } from '../context/PublishTradingOfferModalContext';

const PublishTradingOfferModalHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = usePublishTradingOfferModal();

  const modalTitle =
    data.modalActionType === actionTypes.EDIT
      ? t('EditOffer')
      : t('PublishOffer');

  return (
    <Modal.Header>
      <h5 className="modal-title">{modalTitle}</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default PublishTradingOfferModalHeader;
